'use client';

import { c as _c } from "react/compiler-runtime";
import { Checkbox, Tooltip } from '@common/components';
import { SvgDelete } from '@common/icon';
import { cn } from '@core/utils';
import { Image } from '@/components/client';
import { ADDITIONAL_BENEFIT_AMOUNT } from '../../_constants';
import type { CartProductGroup, OptionChangeParams } from '../../_types';
import { CartCount } from './CartCount';
import { CartItemOption } from './CartItemOption';
export interface CartItemProps {
  group: CartProductGroup;
  selectedIds: Set<number>;
  onSelect: (giftCartItemOptionId: number) => void;
  onChangeOption: (giftCartItemOptionId: number, changes: OptionChangeParams) => void;
  onDelete: (giftCartItemOptionId: number) => void;
  onDeleteProduct: (giftCartItemId: number) => void;
  className?: string;
  showBenefitTooltip?: boolean;
}
export const CartItem = t0 => {
  const $ = _c(67);
  const {
    group,
    selectedIds,
    onSelect,
    onChangeOption,
    onDelete,
    onDeleteProduct,
    className,
    showBenefitTooltip: t1
  } = t0;
  const showBenefitTooltip = t1 === undefined ? false : t1;
  const {
    items
  } = group;
  const firstItem = items[0];
  if (!firstItem) {
    return null;
  }
  let t2;
  if ($[0] !== items) {
    t2 = items.some(_temp);
    $[0] = items;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isSoldOut = t2;
  let t3;
  if ($[2] !== items || $[3] !== selectedIds) {
    const selectableItems = items.filter(_temp2);
    t3 = selectableItems.length > 0 && selectableItems.every(item_1 => selectedIds.has(item_1.giftCartItemOptionId));
    $[2] = items;
    $[3] = selectedIds;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const allSelected = t3;
  let t4;
  if ($[5] !== allSelected || $[6] !== items || $[7] !== onSelect || $[8] !== selectedIds) {
    t4 = () => {
      items.forEach(item_2 => {
        if (item_2.soldOutYN) {
          return;
        }
        const isSelected = selectedIds.has(item_2.giftCartItemOptionId);
        if (allSelected) {
          if (isSelected) {
            onSelect(item_2.giftCartItemOptionId);
          }
        } else {
          if (!isSelected) {
            onSelect(item_2.giftCartItemOptionId);
          }
        }
      });
    };
    $[5] = allSelected;
    $[6] = items;
    $[7] = onSelect;
    $[8] = selectedIds;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleGroupSelect = t4;
  let t5;
  if ($[10] !== firstItem.giftCartItemId || $[11] !== onDeleteProduct) {
    t5 = () => {
      onDeleteProduct(firstItem.giftCartItemId);
    };
    $[10] = firstItem.giftCartItemId;
    $[11] = onDeleteProduct;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleGroupDelete = t5;
  const hasOptions = firstItem.optionName.length > 0;
  let t6;
  if ($[13] !== className) {
    t6 = cn("flex flex-col gap-8", className);
    $[13] = className;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SvgDelete className="size-16" />;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== handleGroupDelete) {
    t8 = <div className="flex items-start justify-end mobile-tablet:px-20"><button type="button" onClick={handleGroupDelete} aria-label={"\uC0C1\uD488 \uC0AD\uC81C"} className="size-16 text-Gray-700">{t7}</button></div>;
    $[16] = handleGroupDelete;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = allSelected && !isSoldOut;
  let t10;
  if ($[18] !== handleGroupSelect || $[19] !== isSoldOut || $[20] !== t9) {
    t10 = <Checkbox checked={t9} onCheckedChange={handleGroupSelect} disabled={isSoldOut} />;
    $[18] = handleGroupSelect;
    $[19] = isSoldOut;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== isSoldOut) {
    t11 = cn("size-full object-cover", {
      "opacity-50": isSoldOut
    });
    $[22] = isSoldOut;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== firstItem.imageUrl || $[25] !== firstItem.productName || $[26] !== t11) {
    t12 = <Image className={t11} src={firstItem.imageUrl} alt={firstItem.productName} width={104} height={104} />;
    $[24] = firstItem.imageUrl;
    $[25] = firstItem.productName;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== isSoldOut) {
    t13 = isSoldOut && <div className="absolute inset-0 bg-Gray-black/40 flex-center"><span className="font-600 text-Gray-white typo-body4">품절</span></div>;
    $[28] = isSoldOut;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t12 || $[31] !== t13) {
    t14 = <div className="relative size-104 shrink-0 overflow-hidden rounded-small border border-Gray-black/5 mobile-tablet:size-72">{t12}{t13}</div>;
    $[30] = t12;
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== firstItem.productName) {
    t15 = <p className="line-clamp-2 font-500 text-Gray-900 typo-body3 mobile-tablet:typo-body4">{firstItem.productName}</p>;
    $[33] = firstItem.productName;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== firstItem.deliveryInfo) {
    t16 = firstItem.deliveryInfo && <span className="font-400 text-Gray-900 typo-body3 mobile-tablet:typo-caption1">{firstItem.deliveryInfo}</span>;
    $[35] = firstItem.deliveryInfo;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== firstItem.giftCartItemOptionId || $[38] !== firstItem.quantity || $[39] !== hasOptions || $[40] !== onChangeOption || $[41] !== onDelete || $[42] !== showBenefitTooltip) {
    t17 = !hasOptions && <div className="flex items-center justify-end pr-12"><Tooltip open={showBenefitTooltip} side="bottom" align="start" isArrow={true} asChild={true} className="z-0" label={<span className="font-400 typo-caption1"><span className="text-O-400">{ADDITIONAL_BENEFIT_AMOUNT.toLocaleString()}원 추가 혜택</span>→ <span className="font-600">답례품 1개 추가</span></span>}><div className="w-fit"><CartCount count={firstItem.quantity} onCountChange={quantity => onChangeOption(firstItem.giftCartItemOptionId, {
            quantity
          })} onDelete={() => onDelete(firstItem.giftCartItemOptionId)} /></div></Tooltip></div>;
    $[37] = firstItem.giftCartItemOptionId;
    $[38] = firstItem.quantity;
    $[39] = hasOptions;
    $[40] = onChangeOption;
    $[41] = onDelete;
    $[42] = showBenefitTooltip;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== t15 || $[45] !== t16 || $[46] !== t17) {
    t18 = <div className="flex flex-1 flex-col gap-6">{t15}{t16}{t17}</div>;
    $[44] = t15;
    $[45] = t16;
    $[46] = t17;
    $[47] = t18;
  } else {
    t18 = $[47];
  }
  let t19;
  if ($[48] !== t14 || $[49] !== t18) {
    t19 = <div className="flex flex-1 gap-12">{t14}{t18}</div>;
    $[48] = t14;
    $[49] = t18;
    $[50] = t19;
  } else {
    t19 = $[50];
  }
  let t20;
  if ($[51] !== t10 || $[52] !== t19) {
    t20 = <div className="flex items-start gap-8">{t10}{t19}</div>;
    $[51] = t10;
    $[52] = t19;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  let t21;
  if ($[54] !== hasOptions || $[55] !== items || $[56] !== onChangeOption || $[57] !== onDelete || $[58] !== showBenefitTooltip) {
    t21 = hasOptions && items.map((item_3, index) => <CartItemOption key={item_3.giftCartItemOptionId} item={{
      optionName: item_3.optionName,
      extraPrice: item_3.extraPrice,
      quantity: item_3.quantity,
      soldOutYN: item_3.soldOutYN
    }} onChangeOption={changes => onChangeOption(item_3.giftCartItemOptionId, changes)} onDelete={() => onDelete(item_3.giftCartItemOptionId)} showBenefitTooltip={showBenefitTooltip && index === 0} />);
    $[54] = hasOptions;
    $[55] = items;
    $[56] = onChangeOption;
    $[57] = onDelete;
    $[58] = showBenefitTooltip;
    $[59] = t21;
  } else {
    t21 = $[59];
  }
  let t22;
  if ($[60] !== t20 || $[61] !== t21) {
    t22 = <div className="flex flex-col gap-12 mobile-tablet:px-20">{t20}{t21}</div>;
    $[60] = t20;
    $[61] = t21;
    $[62] = t22;
  } else {
    t22 = $[62];
  }
  let t23;
  if ($[63] !== t22 || $[64] !== t6 || $[65] !== t8) {
    t23 = <li className={t6}>{t8}{t22}</li>;
    $[63] = t22;
    $[64] = t6;
    $[65] = t8;
    $[66] = t23;
  } else {
    t23 = $[66];
  }
  return t23;
};
function _temp(item) {
  return item.soldOutYN;
}
function _temp2(item_0) {
  return !item_0.soldOutYN;
}